import React, { useState, useEffect }  from 'react';
import { getBestLocation, isReliant, routesArray } from '../../../services/routing/routes';
import { useLocation } from 'react-router-dom';
import { NavItem } from './navItem';

import styles from './primaryNav.module.css';
import { usePermissions } from '../../../services/auth/auth';
import { useRouteInfo } from '../../../services/routing/useRouteInfo';

export const PrimaryNav = () => {

    const location = useLocation();
    /** @type [number[], function(number[]): void] activePageIndex */
    // @ts-ignore
    const [activePageIndex, setActivePageIndex] = useState([]);
    const [offset, setOffset] = useState(0);
    const [highlightSize, setHighlightSize] = useState(65);
    /** @type [number[], function(number[]): void] activePageIndex */
    // @ts-ignore
    const [expandedNavs, setExpandedNavs] = useState([]);
      /** @type [any[], function(any[]): void] activePageIndex */
    // @ts-ignore
    const [allowedRoutesArray, setAllowedRoutesArray] = useState([]);
    const permissions = usePermissions();

    const routeInfo = useRouteInfo();


    // Use this code to test the isReliant function
    // useEffect(() => {
        
    //     console.log('Route Changed to', routeInfo);

    //     const checkRoute = (r) => {

    //         if (r[1].children && Array.isArray(r[1].children))
    //             r[1].children.forEach(checkRoute)

    //         console.log(isReliant(r[1], routeInfo) ? 'Route is reliant' : 'Route is not reliant', r[1], );
    //     }

    //     routesArray.forEach(checkRoute)
    // }, [routeInfo])


    const filterRoutesArray = (arr) => {
        let filteredArr = [];


        for (let i = 0; i < arr.length; i++) {
            let route = arr[i][1];
            let routePermissions = route.permissions ?? [];

            let hasPermission = true;
            for (let j = 0; j < routePermissions.length; j++) {
                if (!permissions?.includes(routePermissions[j]))
                    hasPermission = false;
            }

            let children = (route.children?.length ?? 0 > 0) ? filterRoutesArray(route.children) : undefined;

            if (
                (
                    hasPermission
                    //Exclude any empty routes without feature components that no longer have children (Locations doesn't have branches and zips anymore)
                    && !(!route.featureComponent && (children?.length ?? 0) === 0)
                ) || (
                    //Always include if the user is navigated to the route
                    isReliant(route, routeInfo)
                )
            )
                filteredArr.push([arr[i][0], {...route, children: children}]);
        }


        return filteredArr;
    }

    useEffect(() => {
        setAllowedRoutesArray([...filterRoutesArray(routesArray)]);
    }, [permissions, routeInfo]);

    useEffect(() => {
        setActivePageIndex(getBestLocation(location.pathname, allowedRoutesArray).indexArr);
    }, [location, allowedRoutesArray]);

    useEffect(() => {
        const fullHeight = 48;
        const partialHeight = 37;
        let h = 0;

        for (let i = 0; i < allowedRoutesArray.length; i++) {
            if (i < activePageIndex[0] || (i === activePageIndex[0] && activePageIndex.length != 1 && expandedNavs.includes(i)))
                h += fullHeight;

            if ((allowedRoutesArray[i][1].children?.length ?? 0) > 0 && expandedNavs.includes(i)) {
                for (let j = 0; j < allowedRoutesArray[i][1].children.length; j++) {
                    if (i < activePageIndex[0] || (i == activePageIndex[0] && j < (activePageIndex[1] ?? allowedRoutesArray[i].length))) {
                        h += partialHeight;
                    }
                }
            }
        }

        setHighlightSize((activePageIndex.length > 1 && expandedNavs.includes(activePageIndex[0])) ? partialHeight : fullHeight);

        setOffset(h);
    }, [activePageIndex, allowedRoutesArray]);

    const handleExpandChange = (index, state) => {
        if (state) {
            setExpandedNavs([...expandedNavs, index]);
        } else {
            setExpandedNavs([...expandedNavs.filter(x => x != index)])
        }
    }


    return <div className={styles.PrimaryNav}>
        <div className={styles.Links}>
            <div className={styles.Highlight}
                style={{
                    height: highlightSize,
                    transform: `translateY(${offset}px)`
                }}>
            </div>

            {/* <NavItems 
                routes={allowedRoutesArray}
                handleExpandChange={handleExpandChange}
            /> */}

            {allowedRoutesArray
                .filter(([_, props]) => props.showInNav === true)
                .map(([path, props], i) => <RouteWalker
                    key={path}
                    route={props}
                    index={i}
                    handleExpandChange={handleExpandChange}
                    fullPath={path}
                />)
            }
        </div>
    </div>
}



const RouteWalker = ({
    route,
    index,
    handleExpandChange,
    fullPath = '',
}) => {
    return <NavItem
        to={(route.featureComponent ? fullPath : '#')}
        icon={route.icon}
        label={route.name}
        onExpandChange={x => handleExpandChange(index, x)}
    >
        {(route.children ?? [])
            .filter(([_, props]) => props.showInNav === true)
            .map(([path, props], i) => <RouteWalker
                key={path}
                route={props}
                index={i}
                handleExpandChange={handleExpandChange}
                fullPath={fullPath + path}
            />)
        }
    </NavItem>
}

const NavItems = ({
    routes,
    handleExpandChange,
    parentRoute = '',
}) => {

    const filtered = () => routes.filter(([_, props]) => props.showInNav === true);

    if (filtered().length === 0)
        return <></>;


    return <>
        {filtered().map(([route, props], i) =>
            <NavItem
                key={route}
                to={(props.featureComponent ? parentRoute + route : '#')}
                icon={props.icon}
                label={props.name}
                onExpandChange={x => handleExpandChange(i, x)}
            >
                {props.children ?
                <NavItems
                    routes={props.children}
                    handleExpandChange={handleExpandChange}
                    parentRoute={parentRoute + route}
                />
                :[]}
            </NavItem>
        )}
    </>
}